import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconBpost({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 627.3 443.3"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<defs>
				<linearGradient
					id="a"
					x1={9}
					x2={606.2}
					y1={94.8}
					y2={513}
					gradientTransform="matrix(1 0 0 -1 0 482.8)"
					gradientUnits="userSpaceOnUse"
				>
					<stop offset={0} stopColor="#a21007" />
					<stop offset={0} stopColor="#a60f09" />
					<stop offset={0.4} stopColor="#c20c16" />
					<stop offset={0.6} stopColor="#d3091d" />
					<stop offset={0.8} stopColor="#d9081f" />
				</linearGradient>
				<linearGradient
					xlinkHref="#a"
					id="b"
					x1={111.7}
					x2={311.4}
					y1={259.8}
					y2={399.6}
				/>
			</defs>
			<path
				d="M627.3 0c-86.1 188.7-288 382.3-450.7 431.7-163 49.5-224.2-64.5-136.7-254.1l56.5-17.1C39.1 284.7 79.2 359.3 186 326.9 292.6 294.6 424.9 167.8 481.6 44z"
				style={{
					fill: "url(#a)",
				}}
			/>
			<path
				d="M121.9 152.7c-29.2 63.3-8.8 101.3 45.6 84.9s122-81.1 151-144.3z"
				style={{
					fill: "url(#b)",
				}}
			/>
		</svg>
	);
}
